import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { conditionOperations } from '~/utils'

export const pathKey = 'segmentDefinitions' satisfies PathKey

const schema = z.object({
  segment_definitions: z.array(
    z.object({
      segment_number: z.number().int().min(1).max(9),
      condition_groups: z.array(
        z.array(
          z.object({
            question_id: z.string(),
            operation: z.enum(conditionOperations),
            values: z.array(z.number()),
            text_values: z.array(z.string()),
            use_brand_number_as_answer: z.boolean(),
            use_brand_number_as_question_number: z.boolean(),
          }),
        ),
      ),
    }),
  ),
})
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
